import type { DocNode } from '@atlaskit/adf-schema';
import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import type { DocumentUpdateCommandProcessor } from '../stream-processors/update-command-processor';
import { AIFC_ACTION_CLASSIFICATION_METADATA, AIFC_ADF_UPDATE_KEY } from '../types/command-manager';

import type { PassThroughCommandProps } from './command-handler';
import { StreamingCommandHandler } from './streaming-command-handler';

type AdfUpdatePayload = ConfluenceUpdatePageCommandProperties & {
	key: typeof AIFC_ADF_UPDATE_KEY | typeof AIFC_ACTION_CLASSIFICATION_METADATA;
};

export class UpdateCommandHandler extends StreamingCommandHandler<ConfluenceUpdatePageCommandProperties> {
	constructor(
		props: PassThroughCommandProps,
		private updateCommandProcessor: DocumentUpdateCommandProcessor,
	) {
		super(props, 'update');
	}

	process(payload: AdfUpdatePayload): void {
		if (payload.key === AIFC_ADF_UPDATE_KEY) {
			this.updateCommandProcessor.streamChunk(
				payload.data.toolCalls,
				payload.isStreamComplete,
				payload.traceId,
				payload.singleInstrumentationId,
			);
		} else if (payload.key === AIFC_ACTION_CLASSIFICATION_METADATA) {
			this.updateCommandProcessor.setActionMetadata(payload.data);
		}
	}

	async finishAction(): Promise<DocNode | undefined> {
		await this.updateCommandProcessor.finish();
		return undefined;
	}

	abort(reason?: 'aborted' | 'timeout'): void {
		this.updateCommandProcessor.abort(reason);
	}
}
